module.exports = __webpack_public_path__ + "1-38.gif?95c456ce0b574e19e34c33a0a26f0cef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-38.gif
// module id = 115
// module chunks = 0